/**
 * Cursor Style – Custom Mouse Cursors & Trails — custom cursors and effects
 *
 * Declares a single web-accessible-resource entry to every origin with no
 * `use_dynamic_url`, exposing `resources/*`, `js/chat/*.js`, several `js/effects/*`
 * groups and `css/effects.css`. All are reachable from any page at a fixed URL.
 *
 * The bundled `resources/svg` icons are generic Bootstrap glyphs, so the primary signal
 * is instead a fetch of `js/chat/chatClass.js` — one of this extension's vendor-specific
 * chat-feature scripts, distinctive to it.
 *
 * Manifest verified against version 5.0.1.
 */

import { probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'bmjmipppabdlpjccanalncobmbacckjn';

export const cursorStyle: ExtensionDefinition = {
  id: ID,
  name: 'Cursor Style – Custom Mouse Cursors & Trails for Chrome™',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 100_000,
  notes:
    'js/chat, js/effects, resources and css/effects.css exposed to every origin with no ' +
    'dynamic URL. A fetch of a vendor-specific chat script is conclusive.',
  signals: [
    {
      id: 'war-chat-class-js',
      kind: 'web-accessible-resource',
      description:
        'Fetch js/chat/chatClass.js — a vendor-specific chat-feature script exposed to ' +
        'every origin, distinctive to this extension.',
      weight: 1,
      run: () => probeFetch(ID, 'js/chat/chatClass.js'),
    },
    {
      id: 'war-effects-css',
      kind: 'web-accessible-resource',
      description: 'Fetch css/effects.css — the cursor-effects stylesheet, an independent path.',
      weight: 0.5,
      run: () => probeFetch(ID, 'css/effects.css'),
    },
    {
      id: 'war-messages-manager-js',
      kind: 'web-accessible-resource',
      description:
        'Fetch js/chat/messagesManager.js — a second vendor-specific chat script, ' +
        'corroborating the match.',
      weight: 0.5,
      run: () => probeFetch(ID, 'js/chat/messagesManager.js'),
    },
  ],
};
